/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import {
    useAvailablePlansQuery,
    useBillingCycleQuery,
    useChangePlanStatusQuery,
    useCheckCancelableServiceQuery,
    useModuleMetaQuery,
    usePendingServiceCancellationQuery,
    useRenewPriceQuery
} from 'api/service'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    children: ReactNode
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function Service({ children }: Props) {
    const location = useLocation()
    const id = parseInt(location.pathname?.split('/')[2], 10)
    useModuleMetaQuery(id, { skip: !id })
    useCheckCancelableServiceQuery(id, { skip: !id })
    useRenewPriceQuery(id, { skip: !id })
    usePendingServiceCancellationQuery(id, { skip: !id })
    useAvailablePlansQuery(id, { skip: !id })
    useChangePlanStatusQuery(id, { skip: !id })
    useBillingCycleQuery(id, { skip: !id })

    return (
        <>
            {children}
        </>
    )
}
